<template>
  <Content
    class="col-span-full"
    :title="$route.name"
    :router="{
      name: 'DRIVER_LIST',
    }"
  >
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane
        v-for="tab in types"
        :key="tab.name"
        :lazy="true"
        :label="$t(tab.label)"
        :name="tab.name"
      >
        <component
          :is="tab.name"
          v-if="activeName == tab.name"
          @ruleForm="driver = $event"
          :ruleForm="driver"
          :loading="loading"
        ></component>
      </el-tab-pane>
    </el-tabs>
  </Content>
  <!-- <addCar :driver="driver" :loading="loading" /> -->
</template>
<script>
import addCar from "@/pages/drivers/add";
import { gregorianToJalali } from "@/mixins/gregorianToJalali";
import { getADriver } from "@/api/drivers";
import { isNull } from "@/mixins/isNull";
import BasicInfo from "@/components/driver/tabs/BasicInfo";
import HealthInfo from "@/components/driver/tabs/HealthInfo";
import ProInfo from "@/components/driver/tabs/ProInfo";
import CompanyInfo from "@/components/driver/tabs/CompanyInfo";

export default {
  mixins: [gregorianToJalali, isNull],
  data() {
    return {
      driver: {
        first_name: "",
        last_name: "",
        disabled: false,
        father_name: "",
        birthdate: null,
        national_id: "",
        birth_certificate_number: "",
        mobile: "",
        driving_license_types: "",
        has_certificate_of_non_addiction: false,
        driving_license_id: "",
        status: {
          id: "",
        },
        employee_id: "",
        credit_card_number: "",
        driving_license_expiry_date: "",
        email: "",
        gender: {
          id: 1,
        },
        education: {
          id: "",
        },
        marital_status: {
          id: "",
        },
        health_license_expiry_date: null,
        blood_type: {
          id: "",
        },
        contract_date: null,
        personal_photo: [],
        health_card_photo: [],
        description: "",
        number_of_children: null,
        term_of_the_contract: "",
        smart_card_id: "",
        hourly_salary: "",
        address: {
          postal_address: "",
          postal_code: "",
          province: {
            id: "",
          },
          city: {
            id: "",
          },
          neighborhood: {
            id: "",
          },
        },
      },
      loading: true,
      activeName: "BasicInfo",
      types: [
        {
          name: "BasicInfo",
          label: "BASIC_INFO",
        },
        {
          name: "HealthInfo",
          label: "Health_INFO",
        },
        {
          name: "ProInfo",
          label: "PRO_INFO",
        },
        {
          name: "CompanyInfo",
          label: "COMPANY_INFO",
        },
      ],
    };
  },
  components: {
    addCar,
    BasicInfo,
    HealthInfo,
    ProInfo,
    CompanyInfo,
  },
  mounted() {
    getADriver.api(this.$route.params.id).then((res) => {
      this.driver = {
        ...res,
        mobile: res.mobile ? "0" + res.mobile : "",
        birthdate: this.gregorianToJalali(res.birthdate, this.$i18n.locale),
        driving_license_expiry_date: this.gregorianToJalali(
          res.driving_license_expiry_date
        ),
        health_license_expiry_date: this.gregorianToJalali(
          res.health_license_expiry_date
        ),
        gender: this.isNull(res.gender),
        blood_type: this.isNull(res.blood_type),
        education: this.isNull(res.education),
        marital_status: this.isNull(res.marital_status),
        contract_date: this.gregorianToJalali(res.contract_date),
        disabled: this.$route.name.includes("VIEW") ? true : false,
        id: this.$route.params.id,
        driving_license_types:
          res.driving_license_types &&
          res.driving_license_types.map((i) => i.id),
      };
      this.loading = false;
    });
  },
};
</script>
